import type { FlaggedAreaSafety } from '@chukua/common';

export const FLAGGED_AREA_SAFETY_LABELS: Record<FlaggedAreaSafety, string> = { unsafe: 'Unsafe to stop', safe_stop: 'Safe stop' };

export const FLAGGED_AREA_SAFETY_HINTS: Record<FlaggedAreaSafety, string> = {
  unsafe: 'A stop here is dangerous at any hour and raises an unsafe-stop alert.',
  safe_stop: 'A normal rest place: an overnight stop here is expected and not flagged.',
};

export const FLAGGED_AREA_SAFETY_TAG_COLOURS: Record<FlaggedAreaSafety, string> = { unsafe: 'error', safe_stop: 'success' };
